import { useUserStore } from '@/stores/userStore';
import { useMainStore } from '@/stores/mainStore';
import { useGmApi } from '@/composables/useGmApi';
import { queryClient } from '@/plugins/vueQuery';
import type { Me } from '@/types/users';
import { datadogLogs } from '@datadog/browser-logs';
import { USER_PERMISSION_ROLE_ENUM } from '@/types/permissions';
import { getMeQueryKey } from './queries/users';

export function isSuperAdminRouteGuard() {
  const { user } = useUserStore();
  if (!user?.isSuperAdmin) {
    return { name: 'NotFound' };
  }
}

export async function hydratePermissionsIfMissing() {
  const userStore = useUserStore();
  if (userStore.permissions) return;

  try {
    const me = await queryClient.fetchQuery<Me>({
      queryKey: getMeQueryKey(),
      queryFn: useGmApi().getMe,
      staleTime: Infinity,
      retry: false,
    });
    userStore.setPermissions(me.permissions);
    userStore.setIsSuperAdmin(me.user.isSuperAdmin);
  } catch (error) {
    datadogLogs.logger.error('[router.beforeEach] Failed to load permissions:', { error });
  }
}


export async function canAccessAdminRoutes() {
  const userStore = useUserStore();
  const mainStore = useMainStore();
  const userRole = userStore.permissions?.find((permission) => permission.twrn === mainStore.teamTwrn);
  if (userRole?.role !== USER_PERMISSION_ROLE_ENUM.ADMIN) {
    return { name: 'NotFound' };
  }
}

export async function canAccessAdminRoutesWithSuperAdmin() {
  if (!isSuperAdminRouteGuard()) return; // If the function returns void, the guard has passed.
  return canAccessAdminRoutes();
}
